import { render, staticRenderFns } from "./Webcam.vue?vue&type=template&id=3faf19f7&"
import script from "./Webcam.vue?vue&type=script&lang=js&"
export * from "./Webcam.vue?vue&type=script&lang=js&"
import style0 from "./Webcam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports